var exports = {
  "eH": "x43aef4ae--a55699--descriptions",
  "h_": "x43aef4ae--a55699--description",
  "tz": "x43aef4ae--a55699--description--hidden",
  "ce": "x43aef4ae--a55699--description-line",
};

module.exports = exports;
